module.exports = __webpack_public_path__ + "static/media/icons_Bilan d‚couverte - membres inf‚rieurs.d148d253.svg";